// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2634 ? "2c796e83" : chunkId) + "." + {"2634":"c12ca34e48da0c7a","8093":"229cc8347bc58481"}[chunkId] + ".js";
};